import styled from 'styled-components';

export const Section = styled.section`
  padding: 5rem 1.5rem;
  background: ${({ theme }) => theme.colors.white};
`;

export const Inner = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  text-align: center;
`;

export const Grid = styled.div`
  margin-top: 3rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  text-align: left;
`;

export const MemberCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.border};
  overflow: hidden;
  transition: ${({ theme }) => theme.transitions.base};
  position: relative;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.cardHover};
    transform: translateY(-4px);
  }

  .image {
    aspect-ratio: 3 / 4;
    background: ${({ theme }) => theme.colors.offWhite};
    overflow: hidden;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;
    }

    .ph {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: ${({ theme }) => theme.fonts.heading};
      font-size: 3.5rem;
      color: ${({ theme }) => theme.colors.border};
    }
  }

  &:hover .image img { transform: scale(1.05); }

  .body {
    padding: 1.5rem;
    border-top: 3px solid ${({ theme }) => theme.colors.gold};
  }

  .role {
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.24em;
    color: ${({ theme }) => theme.colors.goldDark};
    font-weight: 700;
    margin-bottom: 0.5rem;
  }

  h3 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.nearBlack};
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.textMuted};
    line-height: 1.6;
  }
`;

export const Empty = styled.div`
  padding: 3rem 1.5rem;
  border: 1px dashed ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.textMuted};
  max-width: 620px;
  margin: 3rem auto 0;
`;
